// src/locales/violations-vi.ts

export default {
  violations: {
    // Dashboard
    dashboard: {
      title: "Tổng quan Vi phạm",
      subtitle: "Theo dõi và quản lý các báo cáo vi phạm bản quyền",
      totalReports: "Tổng báo cáo",
      pendingReports: "Đang xử lý", 
      resolvedReports: "Đã giải quyết",
      rejectedReports: "Từ chối",
      successRate: "Tỷ lệ thành công",
      avgResolutionTime: "Thời gian xử lý TB",
      platformBreakdown: "Phân bố theo Platform",
      violationTypeBreakdown: "Phân bố theo Loại vi phạm",
      trends: "Xu hướng báo cáo",
      recentReports: "Báo cáo gần đây"
    },

    // Form báo cáo
    form: {
      title: "Báo cáo Vi phạm Bản quyền",
      subtitle: "Báo cáo hành vi vi phạm bản quyền để bảo vệ quyền sở hữu trí tuệ",
      selectWork: "Chọn tác phẩm bị vi phạm",
      reportWorkPlaceholder: "Nhập tên Tác phẩm vi phạm...",
      workPlaceholder: "Tìm kiếm tác phẩm của bạn...",
      violationType: "Loại vi phạm",
      selectViolationType: "Chọn loại vi phạm",
      violationUrl: "URL vi phạm",
      platform: "Nền tảng",
      description: "Mô tả chi tiết",
      descriptionPlaceholder: "Mô tả cụ thể về hành vi vi phạm, thời gian phát hiện, tác động...",
      autoDetected: "Tự động phát hiện",
      evidenceFiles: "Bằng chứng",
      declaration: "Tôi xác nhận thông tin trên là chính xác",
      submit: "Gửi báo cáo",
      submitting: "Đang gửi...",
      cancel: "Hủy",
      next: "Tiếp theo",
      previous: "Quay lại",
      
      // Steps
      steps: {
        name: "Bước ${step}",
        selectWork: "Chọn tác phẩm",
        violationInfo: "Thông tin vi phạm", 
        evidence: "Bằng chứng",
        confirmation: "Xác nhận"
      },

      // Validation
      validation: {
        workRequired: "Vui lòng chọn tác phẩm bị vi phạm",
        violationTypeRequired: "Vui lòng chọn loại vi phạm",
        urlRequired: "Vui lòng nhập URL vi phạm",
        urlInvalid: "URL không hợp lệ",
        descriptionRequired: "Vui lòng mô tả chi tiết vi phạm",
        descriptionMinLength: "Mô tả phải có ít nhất 20 ký tự",
        declarationRequired: "Vui lòng xác nhận tính chính xác của thông tin"
      },

      // Success messages
      success: {
        submitted: "Báo cáo vi phạm đã được gửi thành công!",
        updated: "Báo cáo đã được cập nhật",
        deleted: "Báo cáo đã được xóa"
      },

      fileUpload: {
        dragDrop: "Kéo thả file hoặc nhấn để chọn",
        support: "Hỗ trợ: {{ extensionsSupport }} (tối đa {{ maxSizeSupport }} mỗi file)",
        fileSelected: "File đã chọn ({{ count }})",
      },

      evidenceNote: "Lưu ý",
      evidenceDescription: "Bằng chứng càng chi tiết và rõ ràng sẽ giúp việc xử lý báo cáo nhanh chóng và hiệu quả hơn.",

      reminderText: "Quan trọng",
      reminderSubText: "Vui lòng kiểm tra kỹ thông tin trước khi gửi báo cáo.",

      verifyInformation: {
        workLabel: "Thông tin tác phẩm",
        name: "Tên",
        type: "Loại",
        category: "Danh mục",
        violationLabel: "Thông tin vi phạm",
        platformLabel: "Platform",
        descriptionLabel: "Mô tả vi phạm",
        evidenceLabel: "Bằng chứng",
        evidenceText: "{{ count }} file đã tải lên",
        confirmText: "Tôi xác nhận rằng tất cả thông tin trên là chính xác và tôi có quyền sở hữu hợp pháp đối với tác phẩm bị vi phạm. Tôi hiểu rằng việc cung cấp thông tin sai lệch có thể dẫn đến hậu quả pháp lý.",
        identityProtection: "Bảo mật danh tính và khả năng báo cáo ẩn danh"
      }
    },

    // Search functionality
    search: {
      searchWorks: "Tìm kiếm tác phẩm...",
      searchPlaceholder: "Tìm kiếm báo cáo, tác phẩm, URL...",
      noWorksFound: "Không tìm thấy tác phẩm",
      searchHint: "Nhập ít nhất 2 ký tự để tìm kiếm",
      selectWork: "Chọn tác phẩm từ danh sách",
      selectedWork: "Tác phẩm đã chọn"
    },

    // Severity
    severity: {
      low: "Thấp",
      medium: "Trung bình", 
      high: "Cao",
      critical: "Nghiêm trọng"
    },

    // Platforms
    platforms: {
      facebook: "Facebook",
      instagram: "Instagram",
      youtube: "YouTube",
      tiktok: "TikTok", 
      twitter: "Twitter/X",
      linkedin: "LinkedIn",
      website: "Website",
      other: "Khác"
    },

    // Table headers
    table: {
      id: "ID",
      work: "Tác phẩm",
      violationType: "Loại vi phạm",
      platform: "Nền tảng", 
      url: "URL vi phạm",
      reportDate: "Ngày báo cáo",
      status: "Trạng thái",
      severity: "Mức độ",
      evidence: "Bằng chứng",
      actions: "Thao tác",
      violator: "Người vi phạm",
      detectionTime: "Thời gian phát hiện",
      owner: "Chủ sở hữu"
    },

    // Actions
    actions: {
      view: "Xem",
      edit: "Sửa", 
      delete: "Xóa",
      report: "Báo cáo",
      confirm: "Xác nhận",
      reject: "Từ chối",
      legalAction: "Hành động pháp lý",
      dismiss: "Bỏ qua",
      refresh: "Làm mới",
      export: "Xuất",
      filter: "Lọc",
      search: "Tìm kiếm",
      sort: "Sắp xếp"
    },

    // Filters
    filters: {
      allStatuses: "Tất cả trạng thái",
      allTypes: "Tất cả loại vi phạm", 
      allPlatforms: "Tất cả nền tảng",
      allSeverities: "Tất cả mức độ",
      clearFilters: "Xóa bộ lọc",
      appliedFilters: "Bộ lọc đã áp dụng"
    },

    // Modal content
    modal: {
      title: "Chi tiết báo cáo vi phạm #{{id}}",
      violationId: "Mã báo cáo vi phạm",
      violatedWork: "Tác phẩm bị vi phạm",
      owner: "Chủ sở hữu",
      platform: "Nền tảng",
      violationType: "Loại vi phạm", 
      severity: "Mức độ vi phạm",
      detectionTime: "Thời gian phát hiện",
      violationUrl: "URL vi phạm",
      violator: "Người vi phạm",
      evidence: "Bằng chứng",
      actions: "Các hành động đã thực hiện",
      noActionsRecorded: "Chưa có hành động nào được ghi nhận",
      close: "Đóng",
      
      // Delete confirmation
      deleteTitle: "Xác nhận xóa báo cáo",
      deleteMessage: "Bạn có chắc chắn muốn xóa báo cáo này không?",
      deleteWarning: "Hành động này không thể hoàn tác",
      deleteNote: "Báo cáo chỉ có thể xóa khi đang ở trạng thái 'Đang xử lý'"
    },

    // Messages
    messages: {
      noViolationsFound: "Không tìm thấy vi phạm nào",
      noReports: "Bạn chưa gửi báo cáo vi phạm nào",
      createFirstReport: "Tạo báo cáo đầu tiên",
      loadingReports: "Đang tải danh sách báo cáo...",
      loadingError: "Đã xảy ra lỗi khi tải dữ liệu",
      tryAgain: "Thử lại",
      contactSupport: "Liên hệ hỗ trợ",
      needHelp: "Cần hỗ trợ?",
      helpDescription: "Nếu bạn gặp khó khăn trong việc báo cáo vi phạm hoặc cần tư vấn pháp lý"
    }
  },

  // violations details translations
  violationDetails: {
    title: "Thông tin chi tiết vi phạm",
    tabs: {
      overview: "Tổng quan",
      evidence: "Bằng chứng",
      complaints: "Phản ứng"
    },
    downloadReport: "Tải vi phạm",
    violationInfo: "Thông tin vi phạm",
    detectedDate: "Ngày báo cáo",
    description: "Mô tả vi phạm",
    complaints: "Danh sách khiếu nại ({{count}})",
    createComplaint: "Thêm khiếu nại",
    noComplaints: "Không có khiếu nại nào",
    contentInfo: "Thông tin Tác phẩm",
    contentTitle: "Tiêu đề Tác phẩm",
    unknownContent: "Chưa xác định",
    contentId: "Mã Tác phẩm",
    contentOwner: "Thông tin Tác giả",
    actionsHistory: "Nhật ký",
    systemInfo: "Thông tin hệ thống",
    createdAt: "Ngày báo cáo",
    updatedAt: "Ngày cập nhật",
    appCreatedBy: "Người báo cáo",
    processMetadata: "Nhật ký xử lý vi phạm",
    technicalSummary: 'Tóm tắt',
    
  },

  // violations common translations
  violationCommon: {
    violationStatus: "Trạng thái vi phạm",
    violationType: "Loại vi phạm",
    types: {
      codeCopyrightInfringement: "Vi phạm Bản quyền",
      codeTrademarkViolation: "Vi phạm Nhãn hiệu",
      codeUnauthorizedUsage: "Sử dụng trái phép",
      codePlagiarism: "Đạo văn",
      codeDeepfake: "Giả mạo",
      codeContentTheft: "Trộm cắp nội dung",
      codeLicenseViolation: "Vi phạm Giấy phép",
      codeImpersonation: "Mạo danh Tác giả",
      codeContractViolation: "Vi phạm hợp đồng",
      codeOther: "Khác"
    },
    
    status: {
      codeDetected: "Đã phát hiện",
      codeVerified: "Đã xác minh",
      codeNotified: "Đã thông báo",
      codeAcknowledged: "Đã xác nhận",
      codeContentRemoved: "Nội dung đã xóa",
      codeContentModified: "Nội dung đã sửa đổi",
      codeDisputeFiled: "Tranh chấp đã nộp",
      codeUnderReview: "Đang xem xét",
      codeResolved: "Đã giải quyết",
      codeDismissed: "Đã bác bỏ",
      codeLegalAction: "Hành động pháp lý",
      codeEscalated: "Đã báo cáo",
      codeExpired: "Đã hết hạn"
    },

    severities: {
      codeLow: "Thấp",
      codeMedium: "Trung bình",
      codeHigh: "Cao",
    },

  },

  // AI Scan specific translations
  aiScan: {
    title: "Quét AI Tự động",
    subtitle: "Sử dụng AI để tự động phát hiện vi phạm bản quyền",

    // Stats section
    stats: {
      aiModelInUse: "AI Model đang sử dụng",
      accuracy: "Độ chính xác", 
      configure: "Cấu hình",
      lastScan: "Lần quét cuối",
      totalScans: "Tổng số lần quét",
      totalViolationsDetected: "Tổng vi phạm phát hiện",
      avgScanTime: "Thời gian quét TB",
      minutes: "phút"
    },

    // New scan section
    newScan: {
      startNewScan: "Bắt đầu quét mới",
      scanning: "Đang quét...",
      scanNote: "Quá trình quét có thể mất vài phút. Bạn có thể đóng trang này và quay lại sau.",
      scanCompleted: "Quét hoàn tất",
      scanCompletedMessage: "Đã hoàn tất quét và phát hiện {{count}} vi phạm tiềm năng", 
      scanAgain: "Quét lại",
      
      // Scan settings
      scanPlatform: "Nền tảng quét",
      allPlatforms: "Tất cả nền tảng",
      websites: "Websites",
      scanDepth: "Độ sâu quét",
      quick: "Nhanh (5-10 phút)",
      standard: "Tiêu chuẩn (15-30 phút)", 
      deep: "Sâu (45-90 phút)",
      violationType: "Loại vi phạm cần quét",
      allViolationTypes: "Tất cả loại vi phạm",
      unauthorizedUsage: "Sử dụng trái phép",
      deepfake: "Deepfake",
      impersonation: "Mạo danh",
      contractViolation: "Vi phạm hợp đồng",
      
      // Additional options
      additionalOptions: "Tùy chọn bổ sung",
      enableDeepfake: "Bật phát hiện Deepfake",
      enableImpersonation: "Bật phát hiện mạo danh",
      startScan: "Bắt đầu quét"
    },

    // Detection results
    detectionResults: {
      title: "Kết quả phát hiện",
      filter: "Lọc",
      exportReport: "Xuất báo cáo",
      downloadCsv: "Tải CSV",
      work: "Tác phẩm",
      platform: "Nền tảng",
      violationType: "Loại vi phạm",
      severity: "Mức độ",
      similarity: "Độ tương tự",
      detectionTime: "Thời gian phát hiện",
      actions: "Thao tác",
      view: "Xem",
      report: "Báo cáo"
    },

    // AI Models section
    aiModels: {
      availableModels: "Các AI Model khả dụng",
      modelName: "Tên Model",
      accuracy: "Độ chính xác",
      lastUpdate: "Cập nhật cuối",
      status: "Trạng thái",
      active: "Đang hoạt động",
      inactive: "Không hoạt động", 
      inUse: "Đang sử dụng",
      select: "Chọn"
    },

    // Auto scan schedule
    autoScan: {
      schedule: "Lịch quét tự động",
      frequency: "Tần suất",
      daily: "Hàng ngày",
      weekly: "Hàng tuần", 
      biweekly: "2 tuần một lần",
      monthly: "Hàng tháng",
      scanDepth: "Độ sâu quét",
      dayOfWeek: "Ngày trong tuần",
      monday: "Thứ Hai",
      tuesday: "Thứ Ba",
      wednesday: "Thứ Tư", 
      thursday: "Thứ Năm",
      friday: "Thứ Sáu",
      saturday: "Thứ Bảy",
      sunday: "Chủ Nhật",
      time: "Thời gian",
      timeHint: "Khuyến nghị quét vào ban đêm để tránh ảnh hưởng hiệu suất",
      sendNotification: "Gửi thông báo khi hoàn tất",
      autoCreateReport: "Tự động tạo báo cáo cho vi phạm nghiêm trọng",
      updateSchedule: "Cập nhật lịch"
    },

    // Guide section  
    guide: {
      title: "Hướng dẫn sử dụng",
      manualVsAuto: "Quét thủ công vs Tự động",
      manualVsAutoDesc: "Quét thủ công cho phép bạn kiểm soát cài đặt chi tiết, trong khi quét tự động chạy định kỳ theo lịch.",
      scanDepth: "Độ sâu quét",
      scanDepthDesc: "Quét nhanh kiểm tra các nguồn phổ biến, quét sâu tìm kiếm trên nhiều nền tảng hơn.",
      processingResults: "Xử lý kết quả",
      processingResultsDesc: "AI sẽ đánh giá mức độ tương tự và đề xuất hành động. Bạn có thể xem xét và tạo báo cáo chính thức."
    },

    // Real-time updates
    realTime: {
      connecting: "Đang kết nối...",
      connected: "Đã kết nối",
      disconnected: "Mất kết nối",
      reconnecting: "Đang kết nối lại...",
      currentTask: "Nhiệm vụ hiện tại",
      estimatedTimeRemaining: "Thời gian còn lại ước tính",
      platformsScanned: "Nền tảng đã quét", 
      violationsFound: "Vi phạm đã tìm thấy"
    },

    // Error messages
    errors: {
      scanFailed: "Quét thất bại",
      modelNotAvailable: "AI Model không khả dụng",
      insufficientCredits: "Không đủ credits để quét",
      systemMaintenance: "Hệ thống đang bảo trì",
      networkError: "Lỗi kết nối mạng",
      unknownError: "Lỗi không xác định"
    }
  }
};
